import { getBalance } from "@wagmi/core";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import * as klinecharts from "klinecharts";
import Web3 from "web3";
import v3price from "@utils/v3price";
export default {
  name: "token",
  // metaInfo() {
  //   return {
  //     meta: [
  //       {
  //         property: "og:image",
  //         content: this.metaX.ogImageUrl,
  //       },
  //       {
  //         property: "og:title",
  //         content: this.metaX.ogTitle,
  //       },
  //       {
  //         property: "og:description",
  //         content: this.metaX.ogDescription,
  //       },
  //       {
  //         property: "og:image:type",
  //         content: this.metaX.ogImageType,
  //       },
  //       {
  //         property: "og:image:type",
  //         content: this.metaX.ogImageType,
  //       },
  //       {
  //         property: "og:image:width",
  //         content: this.metaX.ogImageWidth,
  //       },
  //       {
  //         property: "og:image:height",
  //         content: this.metaX.ogImageHeight,
  //       },
  //       {
  //         property: "og:url",
  //         content: this.metaX.ogUrl,
  //       },
  //       {
  //         property: "og:type",
  //         content: this.metaX.ogType,
  //       },
  //     ],
  //   };
  // },
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isConnect", "htmlSize", "btnWalletLoading", "isWallet"]),
    ...userVuex.mapState(["rpc", "token", "userInfo", "etherUSD", "web3Data"]),
    descriptionText() {
      if (this.detail && this.detail.description && this.detail.description.length > 0) {
        return this.isDescriptionExpanded ? this.detail.description : this.detail.description.slice(0, this.descriptionMaxLength) + (this.detail.description.length > this.descriptionMaxLength ? "..." : "");
      } else {
        return "";
      }
    },
    isPhone() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      return /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent);
    }
  },
  data() {
    const tab = [{
      label: this.$lang("Buy"),
      value: "buy"
    }, {
      label: this.$lang("Sell"),
      value: "sell"
    }];
    return {
      isDetailLoading: true,
      popSlippageShow: false,
      tab,
      selectTab: null,
      isTokenInfoLoading: null,
      detail: null,
      nowTime: parseInt(new Date().getTime() / 1000),
      switchNum: 0,
      switchNumInfo: 0,
      tokenBalance: null,
      holder: null,
      holderPage: {
        total: 0,
        page: 1,
        perPage: 40
      },
      tokenAddr: null,
      serverTradeTime: 0,
      blockTradeTime: 0,
      web3Contract: null,
      kLineParams: {
        type: "1m",
        timestamp: 0,
        //首次为0， 取的是最新的数据， 当有数据时的前后翻页由数据中的timestamp取出
        direction: 0,
        // 1表示向前取数据， timestamp为最大时间（不包含）, 0表示向后取数据, timestamp为最小时间（包含）
        token: null,
        perPage: 500
      },
      kLineTotal: 0,
      kLineChart: null,
      tradeList: null,
      tradeListPage: {
        total: 0,
        page: 1,
        perPage: 30,
        sort: "created_time"
      },
      slippage: 0.1,
      minTokenAmt: 0,
      tokenAmt: 0,
      minEtherAmt: 0,
      etherAmt: 0,
      isBtnBuyTokenLoading: false,
      isBtnSellTokenLoading: false,
      isBtnApproveTokenLoading: false,
      isBuyOrSellError: false,
      tokenApproved: null,
      //代币是否授权
      isChartFlag: true,
      tokenLaunched: false,
      kLinePullTimer: null,
      tokenBalanceTimer: null,
      isDescriptionExpanded: false,
      descriptionMaxLength: 140,
      isEqualToPoolEther: true,
      mobileHeadHeight: 0,
      metaX: {
        ogImageUrl: "",
        ogImageWidth: 200,
        ogImageHeight: 200,
        ogImageType: "image/png",
        ogTitle: "",
        ogDescription: "",
        ogUrl: "",
        ogType: "website"
      },
      mLaunchShow: false
    };
  },
  watch: {
    "htmlSize.w": {
      async handler(newW, oldW) {
        if (newW != oldW && this.kLineChart && this.web3Contract) {
          this.$nextTick(() => {
            this.kLineChart.resize();
          });
        }
      },
      deep: true
    },
    selectTab: {
      handler(newVal, oldVal) {
        this.isBuyOrSellError = false;
        if (newVal != oldVal) {
          this.switchNumInfo = null;
        }
        this.switchNum = 0;
      },
      deep: true,
      immediate: true
    },
    switchNum: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.setSwitchInfo();
        }
        console.log("Web3Wallet.feeRate", this.web3Wallet.feeRate);
        //向上取整
        console.log("1 - this.web3Wallet.feeRate / 100", 1 - this.web3Wallet.feeRate / 100);
        const collectEth = Math.ceil(this.detail.web3_collect_eth / (1 - this.web3Wallet.feeRate / 100));
        console.log("collectEth", collectEth, 1 - this.web3Wallet.feeRate / 100);
        const maxTokenValue = this.tokenBalance;
        const maxEtherValue = this.web3Data.balance ? this.web3Data.balance.formatted : 0;
        // console.log("maxTokenValue", newVal, maxTokenValue, maxEtherValue);
        if (this.selectTab === "sell") {
          if (!this.isWallet) {
            this.isBuyOrSellError = false;
          } else if (this.bigNumber(newVal).gt(maxTokenValue)) {
            this.isBuyOrSellError = `Insufficient ${this.detail.symbol}`;
          } else {
            this.isBuyOrSellError = false;
          }
        } else if (this.selectTab === "buy") {
          if (!this.isWallet) {
            this.isBuyOrSellError = false;
          } else if (this.bigNumber(newVal).gt(collectEth)) {
            this.isBuyOrSellError = `Maximum ${this.fmt_pre(collectEth)} ${this.web3Wallet.symbol}`;
          } else if (this.bigNumber(newVal).gt(maxEtherValue)) {
            this.isBuyOrSellError = `Insufficient ${this.web3Wallet.symbol}`;
          } else {
            this.isBuyOrSellError = false;
          }
        }
        if (newVal === 0) {
          this.isBuyOrSellError = false;
        }
      },
      deep: true
    },
    netId: {
      handler(id) {
        if (id) {
          console.log(33333322, id);
          this.noWalletWeb3Init();
        }
      },
      deep: true,
      immediate: true
    },
    isWallet: {
      handler(newBool, oldBool) {
        if (!newBool) return;
        this.walletWeb3Init();
      },
      deep: true,
      immediate: true
    },
    isMobile: {
      handler(newVal, oldVal) {
        if (oldVal !== null && newVal !== oldVal) {
          this.isDescriptionExpanded = false;
          this.descriptionMaxLength = !this.isMobile ? 200 : 25;
          this.$nextTick(() => {
            setTimeout(() => {
              const tokenIntroRef = this.$refs.tokenIntroRef;
              if (tokenIntroRef) {
                console.log("tokenIntroRef.offsetHeight", tokenIntroRef.offsetHeight);
                this.mobileHeadHeight = this.isDescriptionExpanded ? tokenIntroRef.offsetHeight : 0;
              }
              if (this.kLineChart) {
                this.chartOptions(this.kLineChart, "refresh");
                this.kLineChart.resize();
              }
            }, 0);
          });
        }
      },
      deep: true
    },
    isEqualToPoolEther: {
      async handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (newVal != oldVal && !oldVal) {
          await this.queryKLineNewData(this.kLineChart);
          await this.setTradeList();
          await this.setHolderInfo();
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearTimeoutAll();
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapActions(["getTokenInfo", "getLoginInfo", "getTokenHolder", "tokenTradeKline", "tokenTrande", "getTradeNewest"]),
    ...userVuex.mapMutations(["setWeb3Data"]),
    onShare(url) {
      open(url, "target");
    },
    setMeta(detail) {
      this.metaX.ogTitle = `${detail.name} - ${detail.symbol}`;
      this.metaX.ogDescription = `${detail.description}`;
      this.metaX.ogImageUrl = `${detail.icon}`;
      this.metaX.ogUrl = location.href;
      this.$nextTick(() => {
        this.$meta().refresh(); // 手动刷新 meta 信息
      });
    },

    clearTimeoutAll() {
      clearTimeout(_v.kLinePullTimer);
      clearInterval(_v.tokenBalanceTimer);
    },
    onToggleDescriptionExpand() {
      this.isDescriptionExpanded = !this.isDescriptionExpanded;
      if (!this.isMobile) {
        return;
      }
      this.$nextTick(() => {
        const tokenIntroRef = this.$refs.tokenIntroRef;
        if (tokenIntroRef) {
          console.log("tokenIntroRef.offsetHeight", tokenIntroRef.offsetHeight);
          this.mobileHeadHeight = this.isDescriptionExpanded ? tokenIntroRef.offsetHeight : 0;
        }
      });
    },
    onShowSetting() {
      this.popSlippageShow = true;
    },
    async walletWeb3Init() {
      this.switchNum = 0;
      // await this.noWalletWeb3Init();
    },

    goTrade() {
      if (this.detail) {
        open(`${this.uniswap_url}/?inputCurrency=${this.web3Wallet.symbol}&outputCurrency=${this.tokenAddr}`, "_blank");
      }
    },
    async noWalletWeb3Init() {
      try {
        this.isDetailLoading = true;
        await this.web3Wallet.web3BasicQueryFn();
        console.log("this.$route.params", this.$route.params);
        this.tokenAddr = this.$route.params.id;
        if (!this.tokenAddr) {
          return;
        }
        this.mLaunchShow = true;
        this.kLineParams.token = this.tokenAddr;
        this.kLineTotal = this.kLineParams.perPage;
        this.isDetailLoading = false;
        await this.setTokenInfo();
        this.getTokenBalance();
        this.initChart();
        await this.setTradeList();
        await this.setHolderInfo();
        clearInterval(_v.tokenBalanceTimer);
        _v.tokenBalanceTimer = setInterval(() => {
          this.getTokenBalance();
        }, this.web3Wallet.time);
        clearTimeout(_v.kLinePullTimer);
        await this.kLinePull();
      } catch (err) {
        console.log("err11111", err);
      }
    },
    async setSwitchInfo() {
      this.switchNumInfo = null;
      await this.web3Wallet.web3BasicQueryFn();
      let switchNum = this.fmt_floatDec(this.switchNum, "wei");
      if (!switchNum) {
        return;
      }
      if (!this.web3Wallet.feeRate) {
        return;
      }
      if (this.selectTab == "buy") {
        switchNum = this.bigNumber(switchNum).times(1 - Number(this.web3Wallet.feeRate) / 100).toString();
      }
      this.tokenAmt = await this.web3Wallet.contract("marspump", "marsPumpAddr").call("calcTokenOut", [this.tokenAddr, switchNum]);
      console.log("this.slippage=========", this.slippage, this.web3Wallet.feeRate, this.tokenAmt);
      this.minTokenAmt = this.bigNumber(this.fmt_floatDec(this.tokenAmt)).times(1 - Number(this.slippage) / 100); //显示的滑点要加上1， 表示平台收的手续费
      this.etherAmt = await this.web3Wallet.contract("marspump", "marsPumpAddr").call("calcEtherOut", [this.tokenAddr, switchNum]);
      this.minEtherAmt = this.bigNumber(this.fmt_floatDec(this.etherAmt)).times(1 - Number(this.web3Wallet.feeRate) / 100).times(1 - Number(this.slippage) / 100); //显示的滑点要加上1， 表示平台收的手续费
      if (this.selectTab === "buy") {
        console.log("this.minTokenAmt======", this.minTokenAmt, this.fmt_floatDec(this.tokenAmt) * (1 - (Number(this.slippage) + Number(this.web3Wallet.feeRate)) / 100));
        this.switchNumInfo = this.fmt_th(this.minTokenAmt, 6);
      } else {
        this.switchNumInfo = this.fmt_th(this.minEtherAmt, 10);
        this.tokenApproved = await this.checkApprove(this.tokenAddr, switchNum);
      }
    },
    onSkip(str, type = "tx", a) {
      if (!str) return;
      let url = null;
      if (!a) {
        url = `${this.web3Wallet.explorer.url}/${type}/${str}`;
      } else {
        url = `${this.web3Wallet.explorer.url}/token/${str}?a=${a}`;
      }
      open(url, "target");
    },
    async onTradeListPage(page) {
      this.tradeListPage.page = page;
      await this.setTradeList();
    },
    async onTradeSort(type) {
      this.tradeListPage.page = 1;
      if (this.tradeListPage.sort === type) {
        this.tradeListPage.sort = "created_time";
      } else {
        this.tradeListPage.sort = type;
      }
      await this.setTradeList();
    },
    async getTokenBalance() {
      try {
        const tokenPoolBalance = await this.web3Wallet.contract("token", this.tokenAddr).call("balanceOf", [this.marsPumpAddr]);
        //const tokenPoolEtherBalance = await this.web3Wallet.getBalance(this.tokenAddr );
        const tokenPoolEther = await this.web3Wallet.contract("marspump", this.marsPumpAddr).call("poolEtherMap", [this.tokenAddr]);
        if (this.tokenLaunched) {
          const result = await this.web3Wallet.contract("v3pool", this.detail.pool).call("slot0", []);
          const sqrtX96 = result[0];
          let web3_pool_price = v3price.price1Per0FromSqrtPriceX96(sqrtX96, 18, 18);
          if (this.tokenAddr.toLowerCase() !== this.detail.pool_token0.toLowerCase()) {
            web3_pool_price = v3price.invertDecimalString(web3_pool_price, 18);
            this.$set(this.detail, "web3_pool_price", web3_pool_price);
          }
        }
        const tokenPoolEtherBalance = {
          formatted: _v.fmt_floatDec(this.bigNumber(tokenPoolEther).toFixed(0)),
          value: tokenPoolEther
        };
        console.log("tokenPoolEtherBalance", tokenPoolEtherBalance.formatted);
        if (tokenPoolEtherBalance) {
          this.$set(this.detail, "web3_pool_ether", tokenPoolEtherBalance.formatted);
          this.$set(this.detail, "web3_collect_eth", this.maxEther - tokenPoolEtherBalance.formatted);
          this.$set(this.detail, "web3_sold_token", this.bigNumber(tokenPoolEtherBalance.formatted).div(this.maxEther).times(100).toFixed(18));
          this.$set(this.detail, "web3_pool_token", this.fmt_floatDec(tokenPoolBalance));
        }
        if (!this.web3Wallet.address) return;
        const etherBalance = await this.web3Wallet.getBalance(this.web3Wallet.address);
        this.setWeb3Data({
          balance: etherBalance
        });
        const tokenBalance = await this.web3Wallet.contract("token", this.tokenAddr).call("balanceOf", [this.web3Wallet.address]);
        this.tokenBalance = tokenBalance ? this.fmt_floatDec(tokenBalance) : 0;
      } catch (err) {
        console.log("err", err);
      }
    },
    async checkLaunched() {
      if (!this.tokenLaunched && Number(this.maxEther) <= Number(this.detail.web3_pool_ether)) {
        this.tokenLaunched = await this.web3Wallet.contract("token", this.tokenAddr).call("launched");
      }
    },
    async onBuyEther() {
      try {
        if (!this.switchNum) {
          this.isBuyOrSellError = `Enter ${this.web3Wallet.symbol}`;
          return;
        }
        if (this.isBtnBuyTokenLoading) {
          return;
        }
        this.isBtnBuyTokenLoading = true;
        this.isBuyOrSellError = false;
        const minTokenAmt = this.fmt_floatDec(this.fmt_sc(this.minTokenAmt), "wei");
        const deadLine = Math.floor(Date.now() / 1000) + 600;
        const ref = this.userInfo.referral;
        const pay = this.fmt_floatDec(this.switchNum, "wei");
        const tx = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("buy", [this.detail.address, pay, minTokenAmt, deadLine, ref], pay);
        console.log("tx=========", tx);
        this.switchNum = 0;
        // clearInterval(this.tokenBalanceTimer);
        await this.getTokenBalance();
        clearTimeout(_v.kLinePullTimer);
        await this.kLinePull();
        await this.getLoginInfo([]);
        this.isBtnBuyTokenLoading = false;
      } catch (err) {
        console.log(err);
        this.isBtnBuyTokenLoading = false;
      }
    },
    async onSellToken() {
      try {
        if (!this.switchNum) {
          this.isBuyOrSellError = `Enter ${this.detail.symbol}`;
          return;
        }
        if (this.isBtnSellTokenLoading) {
          return;
        }
        this.isBtnSellTokenLoading = true;
        if (!this.tokenApproved) {
          const res = await this.setApprove();
          if (!res) {
            this.isBtnSellTokenLoading = false;
            return;
          }
        }
        this.isBuyOrSellError = false;
        const minEtherAmt = this.fmt_floatDec(this.fmt_sc(this.minEtherAmt), "wei").toString();
        let deadLine = Math.floor(Date.now() / 1000) + 600;
        let ref = this.userInfo.referral;
        const pay = this.fmt_floatDec(this.switchNum, "wei").toString();

        //发送
        const tx = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("sell", [this.detail.address, pay, minEtherAmt, deadLine, ref]);
        this.switchNum = 0;
        // clearInterval(this.tokenBalanceTimer);
        await this.getTokenBalance();
        clearTimeout(_v.kLinePullTimer);
        await this.kLinePull();
        this.isBtnSellTokenLoading = false;
      } catch (err) {
        console.log("err", err);
        this.$toasted.error("Sell failed!");
        this.isBtnSellTokenLoading = false;
      }
    },
    async setTokenInfo() {
      const detail = await this.getTokenInfo({
        token: this.tokenAddr
      });
      if (!detail) {
        return;
      }
      this.isTokenInfoLoading = false;
      const item = detail;
      console.log("item.pool_ether", item.volume, _v.fmt_sc(item.volume), _v.fmt_pre(_v.fmt_sc(item.volume)));
      const _item = {
        ...item,
        u_marketCap: _v.fmt_toPre(_v.bigNumber(item.pool_price).times(item.total_supply).times(this.etherUSD), 0),
        //市值
        u_priceGain24hUsdt: _v.fmt_pre(_v.fmt_sc(item.volume)),
        u_laquidity: _v.fmt_toPre(this.virtuALLaquidity * this.etherUSD)
      };
      this.tokenLaunched = await this.web3Wallet.contract("token", this.tokenAddr).call("launched");
      this.detail = _item;
      this.setMeta(this.detail);
    },
    async setHolderInfo() {
      const holder = await this.getTokenHolder({
        token: this.tokenAddr,
        ...this.holderPage
      });
      if (!holder.items) {
        return;
      }
      this.isTokenInfoLoading = false;
      const list = holder.items.map(item => {
        return {
          ...item,
          ratio: this.fmt_toPre(this.fmt_sc(this.bigNumber(this.fmt_sc(item.amount)).div(item.total_supply).times(100)), 4)
        };
      });
      this.holder = list;
      this.holderPage.total = holder.total;
    },
    onHolderPage(page) {
      this.holderPage.page = page;
      this.setHolderInfo();
    },
    async setTradeList() {
      const trade = await this.tokenTrande({
        token: this.tokenAddr,
        page: this.tradeListPage.page,
        sort: this.tradeListPage.sort,
        perPage: this.tradeListPage.perPage
      });
      if (!trade) {
        return;
      }
      const nowTime = new Date().getTime() / 1000;
      const items = trade.items.map(item => {
        const time = nowTime - item.created_time;
        const _time = this.fmt_cd(time);
        return {
          ...item,
          u_created_time: _time
        };
      });
      this.tradeList = items;
      this.tradeListPage.total = trade.total;
    },
    switchNumInput() {
      const maxDecimalPlaces = 18;
      let value = this.switchNum;
      const regex = new RegExp(`^(?:[1-9]\\d*|0)(?:\\.\\d{0,${maxDecimalPlaces}})?$`);
      if (!regex.test(value)) {
        value = value.slice(0, -1);
      }
      if (value === "-") {
        value = 0;
      }
      this.switchNum = value;
    },
    switchTab(item) {
      this.isBuyOrSellError = false;
      switch (this.selectTab) {
        case "buy":
          this.switchNum = String(item);
          break;
        case "sell":
          if (this.tokenBalance) {
            const balance = this.fmt_toPre(this.tokenBalance, 2);
            this.switchNum = this.fmt_toPre(balance * item, 2);
          }
          break;
      }
    },
    async setApprove() {
      return new Promise(async (resolve, reject) => {
        try {
          let approveAmt = this.web3Wallet.maxUint256;
          // if (this.tokenAmt) {
          //   approveAmt = this.fmt_floatDec(this.switchNum, "wei");
          // }
          const tx = await this.web3Wallet.contract("token", this.tokenAddr).send("approve", [this.marsPumpAddr, approveAmt]);
          console.log(tx.transactionHash);
          this.tokenApproved = await this.checkApprove(this.tokenAddr, approveAmt);
          console.log("this.tokenApproved", this.tokenApproved);
          resolve(1);
        } catch (e) {
          this.$toasted.error("Approve failed!");
          this.isBtnSellTokenLoading = false;
          console.log(e);
          resolve(0);
        }
      });
    },
    async checkApprove(tokenAddr, amount) {
      try {
        const allowance = await this.web3Wallet.contract("token", tokenAddr).call("allowance", [this.web3Wallet.address, this.marsPumpAddr]);
        console.log("allowance", allowance, amount);
        return allowance >= amount;
      } catch (err) {
        this.isBtnSellTokenLoading = false;
      }
    },
    async kLinePull() {
      try {
        // let events = await this.web3Contract.getPastEvents("TokenTrade", {
        //   filter: {}, // 你可以设置过滤器来过滤事件
        //   fromBlock: "latest",
        //   toBlock: "latest",
        // });
        // // console.log("TokenTrade");
        // // console.log(events); // 打印所有找到的事件
        // if (events.length > 0) {
        //   //监听到新的交易, 并且是该代币的交易, 并且最后的交易单的时间变化了
        //   if (events[0].returnValues.token && events[0].returnValues.token == this.tokenAddr) {
        //     this.blockTradeTime = events[0].returnValues.tradeTime; //记录区块交易时间
        //   }
        // }

        // if (this.blockTradeTime > this.serverTradeTime) {

        // }
        if (this.tokenLaunched) {
          console.log("launched", "db_price", this.detail.pool_price, "web3_price", this.detail.web3_pool_price, BigInt(Math.floor(this.detail.pool_price * 10 ** 18)) === BigInt(Math.floor(this.detail.web3_pool_price * 10 ** 18)));
          if (BigInt(Math.floor(this.detail.pool_price * 10 ** 18)) === BigInt(Math.floor(this.detail.web3_pool_price * 10 ** 18))) {
            this.isEqualToPoolEther = true;
          } else {
            this.$set(this.detail, "pool_price", this.detail.web3_pool_price);
            this.isEqualToPoolEther = false;
          }
        } else {
          const web3_pool_ether = this.detail.web3_pool_ether;
          const pool_ether = this.detail.pool_ether ? this.detail.pool_ether : 0;
          console.log("未迁到外盘, 链上pool_ether: ", web3_pool_ether, ", 接口pool_ether：", pool_ether, ", 链上pool_ether是否完全等于接口pool_ether: ", this.bigNumber(web3_pool_ether).isEqualTo(pool_ether));
          if (!this.bigNumber(web3_pool_ether).isEqualTo(pool_ether)) {
            const detail = await this.getTokenInfo({
              token: this.tokenAddr
            });
            this.$set(this.detail, "pool_ether", detail.pool_ether);
            this.isEqualToPoolEther = false;
          } else {
            this.isEqualToPoolEther = true;
          }
        }
        await this.checkLaunched();
        _v.kLinePullTimer = setTimeout(async () => {
          await this.kLinePull();
        }, 1000);
      } catch (err) {
        console.log("errr=============1111", err);
      }
    },
    async onChartTab(item) {
      this.kLineParams.type = item;
      await this.queryKLineNewData(this.kLineChart);
    },
    async initChart() {
      if (!this.kLineChart) {
        this.setChartEventWeb3();
        const chartDom = await this.setChartDom();
        if (!chartDom) return;
        const chart = klinecharts.init("chart", {
          layout: [{
            type: "candle"
          }]
        });
        this.chartOptions(chart);
        this.kLineChart = chart;
        await this.queryKLineNewData(chart);
        this.chartSubscribe(chart);
      }
    },
    setChartEventWeb3() {
      const rpc = this.rpc;
      const infoWeb3 = new Web3(rpc);
      this.web3Wallet.eventWeb3 = infoWeb3;
      const web3 = this.web3Wallet.eventWeb3.eth;
      this.web3Contract = new web3.Contract(require(`@web3Contracts/marspump.json`), this.marsPumpAddr);
    },
    async getKLine() {
      const params = this.kLineParams;
      let result = await this.tokenTradeKline(params);
      console.log(result);
      let klineDatas = result.kline;
      for (let i in klineDatas) {
        let klineData = klineDatas[i];
        if (i == 0) {
          this.kLineParams.timestamp = parseInt(klineData.timestamp);
        }
        klineData.timestamp = klineData.timestamp * 1000; //时间戳为毫秒
        //所有数据格式化为美元单位
        // klineData.high = klineData.high * klineData.ether_usd;
        // klineData.open = klineData.open * klineData.ether_usd;
        // klineData.low = klineData.low * klineData.ether_usd;
        // klineData.close = klineData.close * klineData.ether_usd;
        // klineData.volume = klineData.volume * klineData.ether_usd;
        klineData.high = klineData.high * this.etherUSD;
        klineData.open = klineData.open * this.etherUSD;
        klineData.low = klineData.low * this.etherUSD;
        klineData.close = klineData.close * this.etherUSD;
        klineData.volume = klineData.volume * this.etherUSD;
      }
      return result;
    },
    // 查看最新数据
    async queryKLineNewData(chart) {
      this.kLineParams.direction = 0;
      this.kLineParams.timestamp = 0;
      const data = await this.getKLine();
      this.serverTradeTime = data.last; //服务端更新最新的交易时间
      console.log("data.kline4444444", chart, data.kline);
      chart.applyNewData(data.kline);
      setTimeout(() => {
        chart.resize();
      }, 1000);
      if (data.kline.length >= this.kLineParams.perPage) {
        this.isChartFlag = true;
        this.kLineTotal = this.kLineParams.perPage;
      } else {
        this.isChartFlag = false;
      }
    },
    //查看更多数据
    async queryKLineMoreData(chart) {
      this.kLineParams.direction = 1;
      const data = await this.getKLine();
      if (data.kline && data.kline.length > 0) {
        chart.applyMoreData(data.kline);
        chart.resize();
        this.isChartFlag = true;
      }
    },
    //设置图表dom
    setChartDom() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          const chartRef = this.$refs.chartRef;
          if (!chartRef) {
            resolve(0);
            return;
          }
          const chartDiv = document.createElement("div");
          chartDiv.id = "chart";
          chartDiv.style.width = "100%";
          chartDiv.style.height = "100%";
          chartRef.appendChild(chartDiv);
          resolve(1);
        });
      });
    },
    //图表相关设置
    chartOptions(chart, type = "create") {
      if (type === "create") {
        chart.createIndicator("MA", false, {
          id: "candle_pane"
        });
        chart.createIndicator("VOL");
      }
      if (!this.isMobile) {
        chart.setPriceVolumePrecision(10, 10);
      } else {
        chart.setPriceVolumePrecision(8, 8);
      }
      // chart.setZoomEnabled(false);
      // chart.setOffsetRightDistance(0);
      klinecharts.registerLocale("en-US", {
        time: "D:",
        open: "O:",
        high: "H：",
        low: "L：",
        close: "C：",
        volume: "V：",
        turnover: "T:"
      });
      const chartStyle = {
        // 网格线
        grid: {
          show: true,
          horizontal: {
            show: true,
            size: 1,
            color: "#9b98ba08",
            style: "solid",
            dashedValue: [2, 2]
          },
          vertical: {
            show: true,
            size: 1,
            color: "#9b98ba08",
            style: "solid",
            dashedValue: [2, 2]
          }
        },
        // x轴
        xAxis: {
          show: true,
          size: "auto",
          // x轴线
          axisLine: {
            show: true,
            color: "#9b98ba08",
            size: 1
          },
          // x轴分割文字
          tickText: {
            show: true,
            color: "#D9D9D956",
            family: "pFont",
            weight: "300",
            size: !this.isMobile ? 12 : 8,
            marginStart: 4,
            marginEnd: 4
          },
          // x轴分割线
          tickLine: {
            show: true,
            size: 1,
            length: 3,
            color: "#9b98ba08"
          }
        },
        // y轴
        yAxis: {
          show: true,
          size: "auto",
          // y轴线
          axisLine: {
            show: true,
            color: "#1c1c1c",
            size: 1
          },
          // x轴分割文字
          tickText: {
            show: true,
            color: "#fff",
            family: "pFont",
            weight: "300",
            size: !this.isMobile ? 12 : 8,
            marginStart: 4,
            marginEnd: 4
          },
          // x轴分割线
          tickLine: {
            show: true,
            size: 1,
            length: 3,
            color: "#1c1c1c"
          }
        },
        crosshair: {
          show: true,
          horizontal: {
            text: {
              show: true,
              // 'fill' | 'stroke' | 'stroke_fill'
              style: "fill",
              color: "#fff",
              size: !this.isMobile ? 12 : 8,
              family: "pFont",
              weight: "300",
              // 'solid' | 'dashed'
              borderStyle: "solid",
              borderDashedValue: [2, 2],
              borderSize: 1,
              borderColor: "#686D76",
              borderRadius: 2,
              paddingLeft: 4,
              paddingRight: 4,
              paddingTop: 4,
              paddingBottom: 4,
              backgroundColor: "#161725"
            }
          },
          vertical: {
            show: true,
            line: {
              show: true,
              // 'solid'|'dashed'
              style: "dashed",
              dashedValue: [4, 2],
              size: 1,
              color: "#888888"
            },
            text: {
              show: true,
              // 'fill' | 'stroke' | 'stroke_fill'
              style: "fill",
              color: "#FFFFFF",
              size: !this.isMobile ? 12 : 8,
              family: "pFont",
              weight: "300",
              // 'solid' | 'dashed'
              borderStyle: "solid",
              borderDashedValue: [2, 2],
              borderSize: 1,
              borderColor: "#686D76",
              borderRadius: 2,
              paddingLeft: 4,
              paddingRight: 4,
              paddingTop: 4,
              paddingBottom: 4,
              backgroundColor: "#161725"
            }
          }
        },
        candle: {
          tooltip: {
            text: {
              size: !this.isMobile ? 12 : 8
            }
          },
          priceMark: {
            last: {
              text: {
                size: !this.isMobile ? 12 : 8
              }
            }
          }
        },
        indicator: {
          tooltip: {
            text: {
              size: !this.isMobile ? 12 : 8
            }
          }
        }
      };
      chart.setStyles(chartStyle);
      return chart;
    },
    //图表相关事件订阅
    chartSubscribe(chart) {
      chart.subscribeAction("onVisibleRangeChange", async e => {
        const to = e.to;
        const perPage = this.kLineParams.perPage;
        const total = this.kLineTotal;
        if (total - e.to >= total - perPage + 3 && total - e.to <= total - perPage + 20 && this.isChartFlag) {
          this.kLineTotal = total + perPage;
          this.isChartFlag = false;
          await this.queryKLineMoreData(chart);
        }
      });
    },
    onCopy(url) {
      this.$copyText(this.tokenAddr).then(e => {
        console.log(33333, url);
        this.$toasted.clear();
        this.$toasted.success("Copied!");
      }, function (e) {
        console.log("222255", e);
      });
    },
    onShareEarn() {
      if (!this.isWallet) {
        this.doConnect();
        return;
      }
      const url = `${location.href}?ref=${this.userInfo.ref_code}`;
      this.$copyText(url).then(e => {
        console.log(33333, url);
        this.$toasted.clear();
        this.$toasted.success("Copied!");
      }, function (e) {
        console.log("222255", e);
      });
    }
  },
  mounted() {
    this.descriptionMaxLength = !this.isMobile ? 200 : 25;
    const slippage = localStorage.getItem("slippage");
    if (slippage) {
      this.slippage = slippage;
    }
  }
};